import { render } from "./MedicalSejourDetails.vue?vue&type=template&id=ef34982c"
import script from "./MedicalSejourDetails.vue?vue&type=script&lang=js"
export * from "./MedicalSejourDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__